import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import Select from 'react-select'
import StyledSelect from '../components/StyledSelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser, faCloudArrowDown, faCopy } from '@fortawesome/free-solid-svg-icons';

const BE_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const inputOptions = [
  { value: 'mysql', label: 'MySQL' },
  { value: 'postgres', label: 'PostgreSQL' },
  { value: 'mssql', label: 'MS SQL'},
  { value: 'snowflake', label: 'Sknowflake'},
  { value: 'schemarb', label: 'Rails (schema.rb)' },
  { value: 'json', label: 'JSON' },
  { value: 'dbml', label: 'DBML' }
];

const outputOptions = [
  { value: 'json', label: 'JSON' },
  { value: 'mysql', label: 'MySQL'},
  { value: 'postgres', label: 'PostgreSQL'},
  { value: 'oracle', label: 'Oracle' },
  // { value: 'schemarb', label: 'Rails (schema.rb)' },
  { value: 'mssql', label: 'MS SQL' },
  { value: 'go-struct', label: 'GO Struct' }
]
const DBMLTransformPage = (props) => {
  const { editorTheme, appTheme } = props
  const [originalInput, setOriginalinput] = useState('');
  const [outputData, setOutputData] = useState('')
  const [originalInputExt, setOriginalInputExt] = useState('sql')
  const [dataTypeInputOptions, setDataTypeInputOptions] = useState(inputOptions[0])
  const [dataTypeOutputOptions, setDataTypeOutputOptions] = useState(outputOptions[0])
  const [originalOutputExt, setOriginalOutputExt] = useState('json')
  const [showLoading, setShowLoading] = useState(false)

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput(content);
    };
    reader.readAsText(file);
  };

  const handleInputSelectChange = (option) => {
    setDataTypeInputOptions(option)
    const extType = convertDataTypeEditor(option)
    setOriginalInputExt(extType)
  }

  const handleoutputSelectChange = (option) => {
    setDataTypeOutputOptions(option)
    const extType = convertDataTypeEditor(option)
    setOriginalOutputExt(extType)
  }

  const convertDataTypeEditor = (option) => {
    let type = ''
    switch (option?.value) {
      case 'schemarb':
        type = 'ruby'
        break
      case 'json':
        type = 'json'
        break;
      case 'go-struct':
        type = 'go'
        break;
      default:
        type = 'sql'
    }
    return type
  }

  const handleApiRequest = () => {
    const fileInput = document.querySelector('#fileInput');
    const formData = new FormData();
    if (fileInput.files.length > 0) {
      formData.append('file', fileInput.files[0]); // Add the selected file
    } else {
      // If no file is selected, create a file from content
      const defaultContent = originalInput;
      const blob = new Blob([defaultContent], { type: 'text/plain' });
      const defaultFile = new File([blob], `defaultFile.txt`, { type: 'text/plain' });
      formData.append('file', defaultFile); // Add the created file
    }
    formData.append('importDbType', dataTypeInputOptions.value);
    formData.append('exportDbType', dataTypeOutputOptions.value);
    setShowLoading(true);
    fetch(`${BE_API_URL}/api/dbml/importFile`, {
      method: 'POST',
      body: formData, // Use FormData instead of JSON.stringify
    })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          const convertedData = data.convertedContent
          setOutputData(convertedData)
          setShowLoading(false);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  const triggerAPICall = () => {
    if (originalInput !== '' && dataTypeInputOptions && dataTypeOutputOptions) {
      handleApiRequest()
    } else {
      setOutputData('')
      const fileInput = document.querySelector('#fileInput');
      fileInput.value = null
    }
  }

  const handleDownloadFile = () => {
    const outputFileName = `Download ${dataTypeOutputOptions.value}.${originalOutputExt}`
    let outputFiletype = null
    switch(originalOutputExt) {
      case "json":
        outputFiletype = "application/json"
        break;
      case "sql":
        outputFiletype = "application/text"
        break;
      default:
    }
    if (!outputFiletype) {
      return
    }
    const element = document.createElement("a");
    const file = new Blob([outputData], { type: outputFiletype });
    element.href = URL.createObjectURL(file);
    element.download = outputFileName;
    document.body.appendChild(element);
    element.click()
  }

  const handleCopy = () => {
    if (outputData) {
      navigator.clipboard.writeText(outputData);
    }
  }

  useEffect(() => {
    triggerAPICall()
  }, [originalInput, dataTypeOutputOptions, dataTypeInputOptions]);

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Schema Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <StyledSelect appTheme={appTheme} value={dataTypeInputOptions} options={inputOptions} onChange={handleInputSelectChange} />
            <br />
            <Editor 
              height="50vh"
              value={originalInput}
              onChange={(value, event) => setOriginalinput(value)}
              language={originalInputExt}
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <input
              type="file"
              accept='*'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
              id="fileInput"
            />
            <button
              type="button"
              onClick={() => document.querySelector('input[name="file1"]').click()}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>

      <div className="col-span-full xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Output</h3>
          </div>
          <div className="px-4 py-2 text-gray-400  rounded dark:border-gray-600">
            { showLoading && (
              <div role="status" class="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                <span class="sr-only">Loading...</span>
              </div>
            ) }
            <StyledSelect appTheme={appTheme} value={dataTypeOutputOptions} options={outputOptions} onChange={handleoutputSelectChange} />
            <br />
            <Editor 
              height="50vh"
              value={outputData}
              language={originalOutputExt}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <button
              type="button"
              onClick={handleCopy}
              disabled={ !outputData }
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCopy}/>
              &nbsp; Copy
            </button>
            &nbsp;&nbsp;
            <button
              onClick={handleDownloadFile}
              type="button"
              disabled={ !outputData }
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowDown}/>
              &nbsp; Download
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DBMLTransformPage;
